import { Box, Typography } from "@mui/material";

const Attendance = () => {
  return (
    <Box m="20px">
      <Typography variant="h2" fontWeight="bold">
        Attendance
      </Typography>
    </Box>
  );
};

export default Attendance;